import {useState} from 'react';
import {Avatar,Button,TextField,FormControlLabel,Checkbox,Link,Grid,Box,Typography,Alert} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import apis from '../api';
import { apiResult, formToJson, setUserSession } from '../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { useNavigate } from 'react-router';
import { PasswordTextField } from '../Component/MuiEx';
import mechantConfig from '../app/mechant.config';
const SignUp = () => {
  const [fieldErrors, setFieldErrors] = useState()
  const [error,setError] = useState()
  const [acceptTerms,setChecked] = useState(false)
  const navigate = useNavigate()
  const handleChecked = (event) => {
    setChecked(event.target.checked)
  }
  const handleSubmit = (event) => {
    setFieldErrors()
    setError()
    event.preventDefault();
    if(!acceptTerms) {
      setError('Please accept the agreement to sign up!')
      return
    }
    const data = new FormData(event.currentTarget);
    const postdata = formToJson(data)
    postdata.email = postdata.email.trim()
    postdata.phone = postdata.phone.trim()
    postdata.firstname = postdata.firstname.trim()
    postdata.lastname = postdata.lastname.trim()
    
    apis.signUp(postdata).then(ret => {
      apiResult(ret, (data) => {
        setUserSession(data)
        navigate('/user/emailverify')
      }, (error) => setError(error), (errors) => setFieldErrors(errors)) })
  };
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
    <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
    <Avatar sx={{ m: 1,}} src={mechantConfig.getMerchant()?.second_logo}></Avatar>
      <Typography component="h1" variant="h5">Sign up</Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField autoComplete="given-name" name="firstname" required fullWidth id="firstname" label="First Name"
              error={fieldErrors && fieldErrors.firstname ? true : false}
              helperText={fieldErrors && fieldErrors.firstname ? fieldErrors.firstname : ''}
              autoFocus />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField required fullWidth id="lastName" label="Last Name" name="lastname" autoComplete="family-name"
              error={fieldErrors && fieldErrors.lastname ? true : false}
              helperText={fieldErrors && fieldErrors.lastname ? fieldErrors.lastname : ''}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField required fullWidth id="phone" label="Phone number" name="phone" autoComplete="phone"
              error={fieldErrors && fieldErrors.phone ? true : false}
              helperText={fieldErrors && fieldErrors.phone ? fieldErrors.phone : ''}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField required fullWidth id="email" label="Email Address" name="email" autoComplete="email"
              error={fieldErrors && fieldErrors.email ? true : false}
              helperText={fieldErrors && fieldErrors.email ? fieldErrors.email : ''}
            />
          </Grid>
          <Grid item xs={12}>
            <PasswordTextField sx={{width:'100%'}} required fullWidth name="passwd" label="Password" type="password" id="passwd" 
              error={fieldErrors && fieldErrors.passwd ? true : false}
              helperText={fieldErrors && fieldErrors.passwd ? fieldErrors.passwd : ''}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox value="allowExtraEmails" color="primary" onChange={handleChecked}/>}
              label={<Typography variant='body2'>I've read and agree to <a href={mechantConfig.getMerchant()?.agreement} target="_blank">{mechantConfig.getMerchant()?.title} Agreement</a>.</Typography>} />
          </Grid>
        </Grid>
        {error && <Alert severity="error">{error}</Alert>}
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2,bgcolor:mechantConfig.getMerchant()?.color.second ,borderRadius:'25px',padding:'6 35',fontSize:'14px' }}  > Sign Up </Button>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Link href="/user/signin" variant="body2"> Already have an account? Sign in </Link>
          </Grid>
        </Grid>
      </Box>
    </Box>
    </Container>
  );
}
export default SignUp